import { useAuthStore } from "../stores/use-auth-store";
import { AdminRoutes } from "./AdminRoutes";
import { ApplicantRoutes } from "./ApplicantRoutes";
import { IUQRoutes } from "./IUQRoutes";
import { PublicRoutes } from "./PublicRoutes";
import { Spinner } from "@/components/ui/spinner";
import { useEffect } from "react";

export const AppRoutes = () => {
  const { getSessionInformation, isLoading, accessToken, user } =
    useAuthStore();
  useEffect(() => {
    getSessionInformation();
  }, [getSessionInformation]);

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Spinner className="h-12 w-12" />
      </div>
    );
  }

  if (accessToken && user?.role === "APPLICANT") {
    return <ApplicantRoutes />;
  }

  if (accessToken && user?.role === "SYSADMIN") {
    return <IUQRoutes />;
  }

  if (accessToken && user?.role === "IUQ") {
    return <IUQRoutes />;
  }

  if (accessToken && user?.role === "CASADMIN") {
    return <AdminRoutes />;
  }

  if (accessToken && user?.role === "CAOADMIN") {
    return <AdminRoutes />;
  }

  return <PublicRoutes />;
};
